import { createAction, ActionsUnion } from '@housinganywhere/safe-redux';

import { PaymentRequestsResponse } from 'ha/services/osiris/paymentRequests';
import { analytics } from 'ha/utils/Payouts';

export const Types = {
  CREATED: '[payment request] created',
};
export type Types = typeof Types.CREATED;

export const Actions = {
  created: (payReq: PaymentRequestsResponse) =>
    createAction(Types.CREATED, undefined, {
      analytics: analytics.created(payReq),
    }),
};
export type Actions = ActionsUnion<typeof Actions>;
